<template><div><h1 id="projekttypen" tabindex="-1"><a class="header-anchor" href="#projekttypen"><span>Projekttypen</span></a></h1>
<p>Projekttypen — Stammtabelle der Projekttypen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In dieser Tabelle werden Einstellungen definiert, die für jedes verknüpfte <RouteLink to="/referenz/refs/ft.refdata.projekte.html" title="Projekte">Projekt</RouteLink> gelten. Jedes Projekt muss mit einem Projekttyp verknüpft sein.</p>
<p>Pfad: <code v-pre>Projektfinanzierung → Tabellen → Projekttypen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Projekttyp</dt>
<dd>Code/Bezeichnung des Projekttyps.</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung, freies Textfeld für die Beschreibung des Projekttyps.</dd>
<dt>Aktionen (Subframe)</dt>
<dd><RouteLink to="/referenz/refs/ft.refdata.aktionen.html" title="Aktionen">Aktionen</RouteLink> können nur mit einem Projekt verknüpft werden, wenn sie in dieser Zuordnungs-Tabelle aufgeführt sind. Die Zuordnung Aktionen zu Projekttypen kann auch in der View der Aktionen erfasst werden.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionen</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.aktionen.html" title="Aktionen">Aktionen</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.projekte.html" title="Projekte">Projekte</RouteLink></p>
</div></template>


